import MedicationRequestTable from "@/components/Medicine/MedicationRequestTable";

export const EncounterMedicinesTab = () => {
  return <MedicationRequestTable />;
};
